import React from "react";
import Popup from "../components/CusPopup";

const ImageViewPopup = (props) => {
    const { popupTitle, data } = props;

    const handleSetTrigger = () => {
        props.setShowImgView();
    }

    return(
        <Popup className="popUpBox" trigger={props.showImgView} setTrigger={handleSetTrigger}>
           <div style={{ textAlign: "left" }}>
                        <div className="bgBlack fbaPSize rdBoxTop">
                          <div className="row">
                            <div className="col-11">
                              <div className="dcPgmh">
                                {popupTitle}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="fbaPSize">
                          <br />
                          <div className="row" style={{overflowX:"scroll"}}>
                            {/* <div className="col-1"></div> */}
                            <div className="col-10 scrollDiv">
                              <img className="setImgPopupStyle" src={data}></img>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <br /> */}
      
        </Popup>
    )
}

export default ImageViewPopup;